import Vue from "vue";
import VueRouter from "vue-router";
import layout from "@/views/layout";
import { getToken } from '@/utils/auth'
Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/Login/index.vue"),
  },
  {
    path: "/",
    name: "layout",
    component: layout,
    redirect: "/home",
    children: [
      {
        path: "/home",
        name: "home",
        component: () => import("@/views/home/index.vue"),
        meta: {
          name: "首页",
          icon: "el-icon-s-home",
        },
      },
      {
        path: "/agent",
        name: "agent",
        component: () => import("@/views/agentManage/agent.vue"),
        meta: {
          name: "客户服务",
        },
      },
      {
        path: "/agentcontract",
        name: "agentcontract",
        component: () => import("@/views/agentManage/agentcontract.vue"),
        meta: {
          name: "合同签订",
        },
      },
      {
        path: "/fileInfo",
        name: "fileInfo",
        component: () => import("@/views/basicSettings/fileInfo.vue"),
        meta: {
          name: "文件信息",
        },
      },
      {
        path: "/infoPush",
        name: "infoPush",
        component: () => import("@/views/basicSettings/infoPush.vue"),
        meta: {
          name: "信息报送",
        },
      },
      {
        path: "/electricityMeter",
        name: "electricityMeter",
        component: () => import("@/views/basicSettings/electricityMeter.vue"),
        meta: {
          name: "电网输配电表价",
        },
      },
      {
        path: "/userinfo",
        name: "userinfo",
        component: () => import("@/views/customerService/userinfo.vue"),
        meta: {
          name: "零售客户",
        },
      },
      {
        path: "/EASurvey",
        name: "EASurvey",
        component: () => import("@/views/customerService/EASurvey.vue"),
        meta: {
          name: "用电评估调查",
        },
      },
      {
        path: "/ESContract",
        name: "ESContract",
        component: () => import("@/views/customerService/ESContract.vue"),
        meta: {
          name: "代理人合同",
        },
      },
      {
        path: "/Billinquiry",
        name: "Billinquiry",
        component: () => import("@/views/electricityBill/Billinquiry.vue"),
        meta: {
          name: "账单查询(手动)",
        },
      },
      {
        path: "/FillInTheBill",
        name: "FillInTheBill",
        component: () => import("@/views/electricityBill/FillInTheBill.vue"),
        meta: {
          name: "填报账单(手动)",
        },
      },
      {
        path: "/JSDImport",
        name: "JSDImport",
        component: () => import("@/views/SettlementDoc/JSDImport.vue"),
        meta: {
          name: "结算单导入矫正",
        },
      },
      {
        path: "/monthImport",
        name: "monthImport",
        component: () => import("@/views/SettlementDoc/monthImport.vue"),
        meta: {
          name: "按月份导入",
        },
      },
      {
        path: "/comprehensiveJSD",
        name: "comprehensiveJSD",
        component: () => import("@/views/SettlementDoc/comprehensiveJSD.vue"),
        meta: {
          name: "综合一张表结算单",
        },
      },
      {
        path: "/cooperateJSD",
        name: "cooperateJSD",
        component: () => import("@/views/SettlementDoc/cooperateJSD.vue"),
        meta: {
          name: "合作伙伴结算单",
        },
      },
      {
        path: "/everydaydldfimp",
        name: "everydaydldfimp",
        component: () => import("@/views/predictionManage/everydaydldfimp.vue"),
        meta: {
          name: "每日电量电费",
        },
      },
      {
        path: "/everydaydllsk",
        name: "everydaydllsk",
        component: () => import("@/views/predictionManage/everydaydllsk.vue"),
        meta: {
          name: "历史报价",
        },
      },
      {
        path: "/jzycjy",
        name: "jzycjy",
        component: () => import("@/views/predictionManage/jzycjy.vue"),
        meta: {
          name: "矫正预测交易",
        },
      },
      {
        path: "/monthydltj",
        name: "monthydltj",
        component: () => import("@/views/predictionManage/monthydltj.vue"),
        meta: {
          name: "本月用用电量统计",
        },
      },
      {
        path: "/quotationsetting",
        name: "quotationsetting",
        component: () =>
          import("@/views/predictionManage/quotationsetting.vue"),
        meta: {
          name: "报价设定",
        },
      },
      {
        path: "/totalDj",
        name: "totalDj",
        component: () => import("@/views/predictionManage/totalDj.vue"),
        meta: {
          name: "总电量",
        },
      },
      {
        path: "/ycjyzjl",
        name: "ycjyzjl",
        component: () => import("@/views/predictionManage/ycjyzjl.vue"),
        meta: {
          name: "预测交易总电量",
        },
      },
      {
        path: "/admininfo",
        name: "admininfo",
        component: () => import("@/views/userinfo/userinfo.vue"),
        meta: {
          name: "个人中心",
        },
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});
router.beforeEach((to, from, next) => {
  const token = getToken();
  if (token) {
    if (to.meta.name) {
      document.title = "万御-" + to.meta.name;
    }
    next();
  } else {
    document.title = "万御";
    next();
    if (to.name == 'login') return
    router.push("/login");
  }
});
export default router;
